import { Box, Stack, Typography, useTheme } from "@mui/material";
import NavBar from "../../landing/components/NavBar";
import { ScrollArrows } from "../../landing/components";
import SponsorshipRequestForm from "./RequestPillBox";
import { tokens } from "../../../theme";

// Data constants
const navItems = ["Home", "Services", "About", "Testimonials", "Contact Us"];

export default function SponsorshipPage() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box
      sx={{
        bgcolor: colors.primary[900],
        overflow: "hidden",
        minWidth: { xs: "auto", lg: "1280px" },
        minHeight: "100vh",
        overflowX: { xs: "hidden", lg: "visible" },
      }}
    >
      <NavBar navItems={navItems} />

      <Stack
        sx={{
          pt: { xs: "120px", sm: "160px", md: "200px" },
          pb: { xs: "40px", sm: "50px", md: "70px" },
          px: { xs: 3, sm: 4, md: 0 },
          alignItems: "center",
        }}
        spacing={{ xs: 2, md: 3 }}
      >
        <Typography
          sx={{
            fontFamily: "Mulish",
            fontWeight: 900,
            fontSize: { xs: "42px", sm: "42px", md: "56px" },
            color: "#1976d2",
            textAlign: "center",
            lineHeight: { xs: "40px", sm: "50px", md: "64px" },
            maxWidth: { xs: "100%", md: "765px" },
          }}
        >
          Amplify Your Event With <br /> Sponsored Livestreaming
        </Typography>
        <Typography
          sx={{
            fontFamily: "Mulish",
            fontWeight: 400,
            fontSize: { xs: "15px", md: "25px" },
            color: colors.primary[700],
            textAlign: "center",
            maxWidth: { xs: "90%", md: "none" },
          }}
        >
          Partner with us to professionally livestream your talk show and extend
          <br />
          your reach beyond the venue reaching audiences anywhere, in real time.
        </Typography>
      </Stack>

      <Stack sx={{ mx: { xs: 3, md: 0 }, mb: "80px" }}>
        <SponsorshipRequestForm />
      </Stack>

      <Box
        sx={{
          position: "absolute",
          bottom: 24,
          left: "50%",
          transform: "translateX(-50%)",
          display: { xs: "none", md: "block" },
        }}
      >
        <ScrollArrows />
      </Box>
    </Box>
  );
}
